module.exports = __webpack_public_path__ + "static/media/nav_im.c6a5f99f.svg";